var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "15px",
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_7day") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5207\\u56FE",
    transform: "translate(-647.000000, -2312.000000)",
    fill: "#00cfff",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M658.25,2312.75 L658.25,2312 L656.75,2312 L656.75,2312.75 L652.25,2312.75 L652.25,2312 L650.75,2312 L650.75,2312.75 L648,2312.75 C647.447715,2312.75 647,2313.19772 647,2313.75 L647,2326 C647,2326.55228 647.447715,2327 648,2327 L661,2327 C661.552285,2327 662,2326.55228 662,2326 L662,2313.75 C662,2313.19772 661.552285,2312.75 661,2312.75 L658.25,2312.75 L658.25,2312.75 Z M654.875,2324.75 L653.375,2324.75 L654.3125,2320.25 L652.25,2320.25 L652.25,2318.75 L656.75,2318.75 L654.875,2324.75 Z M648.5,2316.5 L648.5,2314.25 L650.75,2314.25 L650.75,2315 L652.25,2315 L652.25,2314.25 L656.75,2314.25 L656.75,2315 L658.25,2315 L658.25,2314.25 L660.5,2314.25 L660.5,2316.5 L648.5,2316.5 Z",
    id: "ic_7day"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDate);
export default __webpack_public_path__ + "static/media/date.461bd97b009d41af6c6ef5343afa4231.svg";
export { ForwardRef as ReactComponent };